import { useContext } from 'react';
import { SnackbarContext } from './SnackbarProvider';
export const useTriggerSnackbar = () => {
    const { triggerSnackbar } = useContext(SnackbarContext);
    return { triggerSnackbar };
};
export const useShow = () => {
    const { show } = useContext(SnackbarContext);
    return { show };
};
//# sourceMappingURL=utils.js.map